import { INCREASE_PROMOENGINE_RETRIES } from '../types'

export default (dispatch) => {
  dispatch({
    type: INCREASE_PROMOENGINE_RETRIES,
  })
}
